import { fetcher } from '../utils'
import { ComponentDefaultMessageVO } from '@repo/types'

export default async (input: ComponentDefaultMessageVO): Promise<ComponentDefaultMessageVO> =>
  fetcher(`/api/defaultMessage/save`, 'POST', input)
